import React from 'react';
import './Privacy.css';

function Privacy() {
    return (
        <div className="privacy-page">
            <div className="privacy-container">
                <h1>Privacy Policy</h1>
                <p className="privacy-updated">Last updated: February 2026</p>

                <section>
                    <h2>Overview</h2>
                    <p>
                        Hirla: LinkedIn Copilot is a browser extension that extracts publicly visible
                        information from LinkedIn profile pages you actively visit. This policy explains
                        what data is accessed and how it is handled.
                    </p>
                </section>

                <section>
                    <h2>Data We Access</h2>
                    <p>The extension reads the following data from LinkedIn profile pages:</p>
                    <ul>
                        <li>Full name</li>
                        <li>Job title</li>
                        <li>Work experience (company, role, dates, location, description)</li>
                    </ul>
                    <p>
                        This data is only read when you explicitly click the <strong>Scrape profile</strong> button
                        on a LinkedIn profile page.
                    </p>
                </section>

                <section>
                    <h2>Data Storage and Transmission</h2>
                    <p>
                        <strong>No data is sent to any server.</strong> All extracted data is saved
                        directly to your computer as a JSON file via your browser's standard download
                        mechanism. The extension does not collect, transmit, store, or share any
                        personal data with Hirla or any third party.
                    </p>
                </section>

                <section>
                    <h2>Permissions Used</h2>
                    <ul>
                        <li>
                            <strong>activeTab / tabs</strong> — required to read the URL of the current
                            tab so the extension can confirm you are on a LinkedIn profile page before
                            activating.
                        </li>
                        <li>
                            <strong>host_permissions (linkedin.com)</strong> — required to inject the
                            content script that reads the profile page DOM.
                        </li>
                    </ul>
                </section>

                <section>
                    <h2>Third-Party Services</h2>
                    <p>
                        The extension interacts only with LinkedIn pages that you navigate to yourself.
                        It does not use analytics, crash reporting, or any other third-party service.
                    </p>
                </section>

                <section>
                    <h2>Contact</h2>
                    <p>
                        If you have any questions about this privacy policy, please contact us at{' '}
                        <a href="mailto:privacy@hirla.work">privacy@hirla.work</a>.
                    </p>
                </section>

                <div className="privacy-back">
                    <a href="/">← Back to hirla.work</a>
                </div>
            </div>
        </div>
    );
}

export default Privacy;
